import { IPreloadedState } from 'shared/types/redux';

export const selectManagementCompany = (state: IPreloadedState) => state.managementCompany;
